export enum ShortCodePollingStatus {
  None = 'None',
  Pending = 'Pending',
  Confirmed = 'Confirmed',
}

export interface IUseShortCodePollStatusParams {
  shortCode?: string;
  skipPolling: boolean;
  pollInterval: number;
}

export interface IUseShortCodePollStatus {
  pollingShortCodeStatus: ShortCodePollingStatus;
  resetPollingStatus: () => void;
}
